import axios from 'axios'

export const city = {
  namespaced: true,
  state: {
    city: { 
      auto: { name: '', longitude: 0, latitude: 0, loaded: false }, 
      manual: { name: '', placeid: '', loaded: false }, 
    },
    cities: [],
  },
  mutations: {
    SET_CITIES (state, cities) {
      state.cities = cities
    },
    SET_CITY_AUTO (state, city) {
      state.city.auto = city
      state.city.auto.loaded = true
    },
    SELECT_CITY (state, index) {
      state.city.manual = state.cities[index]
      state.city.manual.loaded = true
    },
  },
  actions: {
    detect (context) {
      axios
        .get('/api/city/ip/' + context.rootState.locale.locale)
        .then(({ data }) => {
          context.commit('SET_CITY_AUTO', data.city)
        })
    },
    complete ({ commit }, query) {
      if (query.length < 3)
        return
      axios
        .get('/api/city/complete?query=' + query)
        .then(({ data }) => {
          commit('SET_CITIES', data.cities)
        })
    },
    select ({ commit }, index) {
      commit('SELECT_CITY', index)
    },
  },
};